"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const controller_1 = require("./fileinput/controller");
const ui_1 = require("./fileinput/ui");
const dropzone_1 = require("./fileinput/dropzone");
const hasMaxFiles_1 = require("./fileinput/hasMaxFiles");
const fileCounter_1 = require("./fileinput/fileCounter");
const isEmpty_1 = require("./fileinput/isEmpty");
class FileInput {
    constructor() {
        this.initFileInputs();
    }
    initFileInputs() {
        document.querySelectorAll('[data-js-file="input"]').forEach((input) => {
            const controller = new controller_1.FileInputController(input);
            const dropzone = input.closest('[data-js-file="dropzone"]');
            if (dropzone) {
                //Main functionality
                new ui_1.FileInputUI(dropzone, controller, input);
                new dropzone_1.FileInputDropzone(dropzone, input);
                //Detached event listeners
                (0, hasMaxFiles_1.HasMaxFiles)(controller, dropzone);
                (0, fileCounter_1.FileCounter)(controller, dropzone);
                (0, isEmpty_1.FileInputisEmpty)(controller, dropzone);
            }
        });
    }
}
exports.default = FileInput;
